import {get} from 'lodash';
import refactorRespImg from '../../ui/resp-img';

export default data => {
  const gridArr = data.itItemsRep ? get(data, 'itItemsRep', []) : []
  return {
    heading: get(data, 'itHeading', null),
    description: get(data, 'itDescription', null),
    grid: gridArr.map(item => {
      const image = item.itItemsIcon ? refactorRespImg(item.itItemsIcon, [{
        size: 'default',
        key: 'image_size_160x160',
      },{
        size: 'md',
        key: 'image_size_196x196',
      },{
        size: 'lg',
        key: 'image_size_280x280',
      }]): null;
      return {
        title: get(item, 'itItemsTitle', null),
        description: get(item, 'itItemsDescription', null),
        link: get(item, 'itItemsLink.url', null),
        image
      }
    })
  }
}